import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable, of } from "rxjs";
import { StrutturaVO } from "@vo/strutturaVO";
import { env } from "@env/environment";
import { OrganigrammaIncaricatoDTO } from "@dto/organigrammaIncaricatoDTO";
import { OrganigrammaRicercaResponseDTO } from "@dto/organigrammaRicercaResponseDTO";
import { map, catchError } from "rxjs/operators";
import { OrganoAnagrafeEntryDTO } from "@dto/organo-anagrafe-entryDTO";
import { DipendenteVO } from "../vo/dipendenteVO";
import { DipendenteDTO } from "../dto/dipendenteDTO";
import { SettoreVO } from "../vo/settoreVO";
import { SettoreDTO } from "../dto/settoreDTO";
import { MapperSettore } from "../mapper/mapper-settore";

@Injectable({
  providedIn: "root",
})
export class OrganoService {
  private urlStoricoCMU =
    env.DOCUMENTALE_API_URL_BASE +
    env.API_DOCUMENTALE_SETTORE_FASCICOLI +
    env.URL_RICERCA_STORICO_CMU;
  private urlCMU = env.API_URL_BASE + env.API_ORGANIGRAMMA_CMU;
  private urlGerarchiaCMU = env.API_URL_BASE + env.API_ORGANO_GERARCHIA_CMU;
  private urlAlberoCMU = env.API_URL_BASE + env.API_ORGANO_ALBERO_CMU;
  private urlAnagrafe = env.API_URL_BASE + env.API_ORGANO_ANAGRAFE_CF;
  cacheOrgano: Map<String, StrutturaVO[]> = new Map();
  private urlDipendenti = env.API_URL_BASE + env.API_ORGANIGRAMMA_DIP;
  private urlDirigente = env.API_URL_BASE + env.API_ORGANIGRAMMA_DIRIGENTE;

  get urlElencoCMU(): string {
    return env.API_URL_BASE + env.API_ORGANIGRAMMA_ELENCO;
  }

  constructor(
    private httpClient: HttpClient,
    private mapperSettpre: MapperSettore,
  ) {
  }

  getElencoCMU(): Observable<StrutturaVO[]> {
    console.log("URL elenco CMU", this.urlElencoCMU);

    return this.httpClient
        .get<OrganigrammaRicercaResponseDTO[]>(this.urlElencoCMU)
        .pipe(
            map((response) => {
              const responseVO = this.convertDataCMU(response);
              return responseVO;
            }),
            catchError((_) => Observable.of([]))
        );

  }

  getCMU(nome: String): Observable<StrutturaVO[]> {
    console.log("URL CMU", this.urlCMU);
    console.log("URL BASE", env.API_URL_BASE);
    console.log("chiave", nome);
    if (this.cacheOrgano.get(nome)) {
      return of(this.cacheOrgano.get(nome));
    } else {
      return this.httpClient
        .get<OrganigrammaRicercaResponseDTO[]>(this.urlCMU + nome)
        .pipe(
          map((response) => {
            const responseVO = this.convertDataCMU(response);
            this.cacheOrgano.set(nome, responseVO);
            return responseVO;
          }),
          catchError((_) => Observable.of([]))
        );
    }
  }

  getStrutturaAppertenenza(cf: string): Observable<StrutturaVO> {
    console.log("[OrganoService.getStrutturaAppertenenza] cf:", cf);
    return this.httpClient
      .get<OrganoAnagrafeEntryDTO[]>(this.urlAnagrafe + cf)
      .pipe(
        map((response) => this.convertOrganoAnagrafe(response)),
        catchError((_) => Observable.of(new StrutturaVO()))
      );
  }

  convertOrganoAnagrafe(response: OrganoAnagrafeEntryDTO[]): StrutturaVO {
    if (response) {
      console.log("[OrganoService.convertOrganoAnagrafe] response:", response);

      return response
        .filter(
          (entry) =>
            entry.settore.id !== "NULL" ||
            (entry.settore.id === "NULL" &&
              entry.direzioneGenerale.codice !== "NULL")
        )
        .map((entry) => {
          if (entry.settore.id !== "NULL") {
            return {
              id: entry.settore.id,
              nome: entry.settore.nome,
            } as StrutturaVO;
          } else {
            return {
              id: entry.direzioneGenerale.codice,
              nome: entry.direzioneGenerale.descrizione,
            } as StrutturaVO;
          }
        })
        .find(() => true);
    }
  }

  getCmuFigli(codice: String): Observable<StrutturaVO[]> {
    console.log("URL CMU", this.urlCMU);
    console.log("URL BASE", env.API_URL_BASE);
    console.log("chiave", codice);
    return this.httpClient
      .get<OrganigrammaRicercaResponseDTO[]>(this.urlGerarchiaCMU + codice)
      .pipe(
        map((response) => this.convertDataCMU(response)),
        catchError((_) => Observable.of([]))
      );
  }

  getAlberoCmu(radice: String): Observable<Map<String, StrutturaVO[]>> {
    console.log("URL CMU", this.urlCMU);
    console.log("URL BASE", env.API_URL_BASE);
    console.log("radice", radice);
    return this.httpClient
      .get<Map<String, OrganigrammaRicercaResponseDTO[]>>(
        this.urlAlberoCMU + radice
      )
      .pipe(map((response) => this.convertMap(response)));
  }

  private convertMap(
    response: Map<String, OrganigrammaRicercaResponseDTO[]>
  ): Map<String, StrutturaVO[]> {
    const mappaResponse = new Map<String, StrutturaVO[]>();
    console.log("convertMap - response: ", response);
    Object.keys(response).forEach((key) =>
      mappaResponse.set(key, this.convertDataCMU(response[key]))
    );
    return mappaResponse;
  }

  private convertDataCMU(
    organigramma: OrganigrammaRicercaResponseDTO[]
  ): StrutturaVO[] {
    let struttureVO: StrutturaVO[];
    let appoggioNome: string;
    console.log("numero risultati: " + organigramma.length);
    struttureVO = new Array<StrutturaVO>();
    if (organigramma.length !== undefined) {
      for (let j = 0; j < organigramma.length; j++) {
        //    organigramma.forEach(element => {
        const strutturaVO = new StrutturaVO();
        if (organigramma[j].codice != null) {
          strutturaVO.nome = organigramma[j].nome;
          if (strutturaVO.nome.length > 58) {
            appoggioNome = strutturaVO.nome.substring(0, 58) + "...";
          } else {
            appoggioNome = strutturaVO.nome;
          }
        }
        strutturaVO.tipo = organigramma[j].tipo;
        strutturaVO.id = organigramma[j].codice;

        let responsabile = new OrganigrammaIncaricatoDTO();
        if (organigramma[j].responsabile) {
          responsabile = organigramma[j].responsabile;
          strutturaVO.responsabile =
            responsabile.cognome + " " + responsabile.nome;
        } else {
          strutturaVO.responsabile = "";
        }
        strutturaVO.output =
          strutturaVO.id +
          " - " +
          appoggioNome +
          " - " +
          strutturaVO.responsabile;

        struttureVO.push(strutturaVO);
      }
    }
    return struttureVO;
  }

  getDipendenti(nome: String): Observable<DipendenteVO[]> {
    return this.httpClient
      .get(this.urlDipendenti + "ricerca?filtro=" + nome)
      .pipe(
        map((response: DipendenteDTO[]) => this.convertDataDip(response)),
        catchError((_) => Observable.of([]))
      );
  }

  getDirigente(cmuSettore: String): Observable<OrganigrammaIncaricatoDTO> {
    return this.httpClient
      .get(this.urlDirigente + "?cmu=" + cmuSettore)
      .pipe(
        map((response: OrganigrammaIncaricatoDTO) => response),
        catchError((_) => Observable.of(null))
      );
  }

  private convertDataDip(dipendenti: DipendenteDTO[]) {
    let dipendentiVO: DipendenteVO[];

    console.log("numero risultati: " + dipendenti.length);
    dipendentiVO = new Array<DipendenteVO>();
    dipendenti.forEach((element) => {
      const dipendenteVO = new DipendenteVO();
      dipendenteVO.cognome = element.cognome;
      dipendenteVO.nome = element.nome;
      dipendenteVO.cf = element.cf;
      dipendenteVO.cmu = element.cmu;
      dipendenteVO.descrizioneCmu = element.descrizioneCmu;
      dipendenteVO.codiceEnte = element.codiceEnte;
      dipendenteVO.matricola = element.matricola;
      dipendenteVO.output =
        element.cognome + " " + element.nome + " - " + element.cmu;
      let search: DipendenteVO[];
      search = dipendentiVO.filter(
        (dipendente) => dipendente.cf === element.cf
      );
      if (search.length === 0) {
        dipendentiVO.push(dipendenteVO);
      }
    });
    return dipendentiVO;
  }

  // tslint:disable-next-line:comment-format
  //recupera le strutture salvate su documentale

  getStoricoCMU(nome: String): Observable<SettoreVO[]> {
    console.log("URL STORICO CMU", this.urlStoricoCMU);
    console.log("chiave", nome);
    return this.httpClient.get(this.urlStoricoCMU + nome).pipe(
      map((response: SettoreDTO[]) =>
        this.mapperSettpre.convertListDtoToVo(response)
      ),
      catchError((_) => Observable.of([]))
    );
  }

  /**
   * Verifica se una struttura è valida chiamando l'endpoint organigrammaRicerca
   * @param codice Il codice della struttura da verificare
   * @returns Observable<boolean> true se la struttura è valida (ha risultati), false altrimenti
   */
  verificaStruttura(codice: string): Observable<boolean> {
    console.log("[OrganoService.verificaStruttura] codice:", codice);
    return this.httpClient
      .get<OrganigrammaRicercaResponseDTO[]>(this.urlCMU + codice)
      .pipe(
        map((response) => {
          // La struttura è valida se la risposta contiene almeno un elemento
          const isValida = response && response.length > 0;
          console.log("[OrganoService.verificaStruttura] codice:", codice, "valida:", isValida);
          return isValida;
        }),
        catchError((_) => {
          console.log("[OrganoService.verificaStruttura] errore per codice:", codice);
          return of(false);
        })
      );
  }
}
